'use client';
// import React from 'react';
import createSvgIcon from "@mui/material/utils/createSvgIcon";
import * as React from 'react';

export default createSvgIcon(
  <path d="M6.9,5.1C9,6.7,11.2,9.8,12,11.5c0.8-1.7,3-4.8,5.1-6.4C18.6,4,21,3.2,21,5.9c0,0.5-0.3,4.6-0.5,5.3c-0.6,2.3-3,2.9-5.1,2.5 c3.6,0.6,4.6,2.7,2.6,4.7c-3.8,3.9-5.5-1-5.9-2.2C12,16,12,15.9,12,16c0-0.1,0,0-0.1,0.2c-0.4,1.2-2.1,6.1-5.9,2.2 c-2-2.1-1.1-4.1,2.6-4.7c-2.1,0.4-4.4-0.2-5.1-2.5C3.3,10.5,3,6.5,3,5.9C3,3.2,5.4,4,6.9,5.1L6.9,5.1z"/>,
  'Bluesky',
);